import React from "react";
import { createStyles } from "@mantine/core";
import { Link } from "react-router-dom";
import { getRoutePath } from "../../../../hooks/useNavigateRoute";
import { linkStyle } from "./shared";

const useStyles = createStyles(() => ({
  link: linkStyle,
}));

export const PaymentLink: React.FC<{ paymentId: number }> = ({ paymentId }) => {
  const { classes } = useStyles();
  return (
    <>
      {" - ("}
      <Link to={getRoutePath("payment", { id: paymentId })} className={classes.link}>
        Payment# {paymentId}
      </Link>
      {")"}
    </>
  );
};
